import { useCallback, useEffect, useState } from 'react';
import { getNoticeList } from 'src/services/api';
import { useModal } from 'src/ModalContext';
import Notice from '.';
import { useParams } from 'react-router';
import NoticeDetail from './Detail';
import { NOTICE_CATEGORY } from 'src/constants/common';

export default function NoticeContainer(): JSX.Element {
  const [list, setList] = useState([] as NoticeItem[]);
  const { errorModal } = useModal();
  const { detail } = useParams() as {
    detail: string;
  };

  useEffect(() => {
    getNoticeList()
      .then((res) => {
        setList(res.notices.filter(({ category }) => category === NOTICE_CATEGORY.COMMON || category === NOTICE_CATEGORY.BIXBY));
      })
      .catch(errorModal);
  }, []);

  const getItem = useCallback(() => {
    if (!detail) {
      return;
    }
    const item = list.find((item) => item.id === +detail);
    return item;
  }, [list, detail]);

  return <>{!!getItem() ? <NoticeDetail item={getItem() as NoticeItem} /> : <Notice list={list} />}</>;
}
